'use client'

import { TbPhotoVideo } from 'react-icons/tb'

export default function WeekVideoSection() {
	return (
		<div className='relative bg-brandsky-900 pb-20 overflow-hidden'>
			<TbPhotoVideo className="absolute bottom-[20px] left-[-40px] w-40 h-40 sm:w-64 sm:h-64 text-white opacity-10 pointer-events-none z-0" />

			<div className='lg:max-w-4xl xl:max-w-5xl 2xl:max-w-7xl mx-auto px-4 relative z-10'>
				<h1 className="text-4xl lg:text-5xl font-bold text-white mb-10 drop-shadow-sm header uppercase text-center">
					Зуслангийн долоо хоног ингэж л өнгөрдөг
				</h1>

				<div className="flex justify-center">
					<div className="w-full max-w-6xl aspect-video">
						<iframe
							className="w-full h-full rounded-xl shadow-lg"
							src="https://www.youtube.com/embed/TWvOWU-VKvs"
							title="Нарс зуслан долоо хоног"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							allowFullScreen
						></iframe>
					</div>
				</div>
			</div>
		</div>
	)
}
